import { en as authEn, fa as authFa } from './auth';
import { en as commonEn, fa as commonFa } from './common';
import { en as copyEn, fa as copyFa } from './copy';
import { en as extraEn, fa as extraFa } from './extra';
import { en as landingEn, fa as landingFa } from './landing';
import { en as policiesEn, fa as policiesFa } from './policies';
import { en as reportsEn, fa as reportsFa } from './reports';
import { en as uiEn, fa as uiFa } from './ui';
import { en as workspaceEn, fa as workspaceFa } from './workspace';

const prefix = <P extends string, T extends Record<string, string>>(name: P, values: T) =>
  Object.fromEntries(Object.entries(values).map(([key, value]) => [`${name}.${key}`, value])) as {
    [K in keyof T & string as `${P}.${K}`]: T[K];
  };
export const en = {
  ...prefix('policies', policiesEn),
  ...copyEn,
  ...commonEn,
  ...prefix('extra', extraEn),
  language: 'Language',
  unexpectedError: 'Something went wrong. Please try again.',
  ...prefix('auth', authEn),
  ...prefix('workspace', workspaceEn),
  ...prefix('reports', reportsEn),
  ...prefix('ui', uiEn),
  ...prefix('landing', landingEn),
} as const;
export const fa: Record<keyof typeof en, string> = {
  ...prefix('policies', policiesFa),
  ...copyFa,
  ...commonFa,
  ...prefix('extra', extraFa),
  language: 'زبان',
  unexpectedError: 'مشکلی پیش آمد. لطفاً دوباره تلاش کنید.',
  ...prefix('auth', authFa),
  ...prefix('workspace', workspaceFa),
  ...prefix('reports', reportsFa),
  ...prefix('ui', uiFa),
  ...prefix('landing', landingFa),
};
